<!--
 * @Author: gaochen
 * @Date: 2022-10-12 16:02:33
 * @LastEditors: gaochen
 * @LastEditTime: 2022-10-12 21:23:18
 * @FilePath: /snail-official/src/views/companyCulture/index.vue
 * @Description: 企业文化
 * No Bug
-->
<template>
  <div class="">
    <header-wrapper></header-wrapper>
    <div class="companyCulture mediaScale">
      <div class="wrapper">
        <div class="title">
          <div class="name">
            <img src="../../assets/img/tit_left.png" alt="">
            企业文化
          </div>
          <div class="label">CORPORATE CULTURE</div>
        </div>
      <div class="cultureImgBox animate__fadeInUp animate__animated">
        <div v-for="(item, index) in cultureList" :key="index" class="imgWrapper cultureList">
          <div class="cultureList_item">
            <img :src="item.imgUrl" alt="">
            <div class="cultureList_item_right">
              <p class="p1">{{ item.name }}</p>
              <p class="p2">{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="employeeStyle ">
      <div class="wrapper">
        <div class="title">
          <div class="name">员工生活</div>
          <div class="label">EMPLOYEE STYLE</div>
        </div>
        <div class="employImgBox mediaScale">
          <div v-for="(item,index) in employeeStyle" :key="index" class="imgWrapper">
            <swiper :ref="`${item.name}Swiper`" :options="item.swiperOption" :class="`${item.name}Swiper`">
              <swiper-slide v-for="swiperItem in item.imgNum" :key="swiperItem">
                <img width="100%" :src="require(`../../assets/img/culture/${item.name}/${swiperItem}.png`)" alt="">
              </swiper-slide>
            </swiper>
            <div :class="[`${item.name}-swiper-button-prev`,'swiper-button-prev-new','swiper-button']"></div>
            <div :class="[`${item.name}-swiper-button-next`,'swiper-button-next-new','swiper-button']"></div>
            <div :class="['mask',`mask${item.index}`]" :style="{'background-color':`${item.bgColor}`}">
              <p :class="[`maskP${item.index}`]">{{item.label}}
                <img :src="require(`../../assets/img/${item.lineImgUrl}.png`)" alt="" class="line">
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-wrapper></footer-wrapper>
  </div>
</template>
<script>
import footerWrapper from "@/components/footer";
import headerWrapper from "@/components/header";
export default {
  name: 'CompanyCulture',
  components: { headerWrapper, footerWrapper },
  data(){
    return{
      cultureList: [
        { name:'创新驱动', imgUrl:require("../../assets/img/culture/mainImg1.png"), desc: '锐意进取，创新发展'},
        { name:'品质第一', imgUrl:require("../../assets/img/culture/mainImg2.png"), desc: '品质优先，持续提升'},
        { name:'用户至上', imgUrl:require("../../assets/img/culture/mainImg3.png"), desc: '用户为本，持续改进'},
        { name:'合作共赢', imgUrl:require("../../assets/img/culture/mainImg4.png"), desc: '携手共进，合作共赢'}
      ],
      employeeStyle:[
        {name:'life',label:'周年年会', lineImgUrl: 'line3', index:'1',bgColor:'#FEB35B',imgNum:1,swiperOption:{
        grabCursor: true,
        centeredSlides: true,
        loop: true,
        observer:true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        navigation:{
          nextEl: '.life-swiper-button-next',
          prevEl: '.life-swiper-button-prev',
        }
        }},
        {name:'tourism',label:'旅游团建',index:'2', lineImgUrl: 'line3',bgColor:'#43BDD3',imgNum: 7,swiperOption:{
        grabCursor: true,
        centeredSlides: true,
        loop: true,
        observer:true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        navigation:{
          nextEl: '.tourism-swiper-button-next',
          prevEl: '.tourism-swiper-button-prev',
        }
        }},
        {name:'birthday',label:'生日会',index:'3',  lineImgUrl: 'line2',bgColor:'#E27FAB',imgNum:3,swiperOption:{
        grabCursor: true,
        centeredSlides: true,
        loop: true,
        observer:true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        navigation:{
          nextEl: '.birthday-swiper-button-next',
          prevEl: '.birthday-swiper-button-prev',
        }
        }},
        {name:'festival',label:'节日活动',index:'4', lineImgUrl: 'line3',bgColor:'#E97D7D',imgNum:4,swiperOption:{
        grabCursor: true,
        centeredSlides: true,
        loop: true,
        observer:true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        navigation:{
          nextEl: '.festival-swiper-button-next',
          prevEl: '.festival-swiper-button-prev',
        }
        }},
        {name:'club',label:'社团俱乐部',index:'5', lineImgUrl: 'line4',bgColor:'#7774DA',imgNum:4,swiperOption:{
        grabCursor: true,
        centeredSlides: true,
        loop: true,
        observer:true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        navigation:{
          nextEl: '.club-swiper-button-next',
          prevEl: '.club-swiper-button-prev',
        }
        }},
        {name:'afternoonTea',label:'下午茶',index:'6', lineImgUrl: 'line2',bgColor:'#AA6FDC',imgNum: 4,swiperOption:{
        grabCursor: true,
        centeredSlides: true,
        loop: true,
        observer:true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        navigation:{
          nextEl: '.afternoonTea-swiper-button-next',
          prevEl: '.afternoonTea-swiper-button-prev',
        }
        }}
      ],
    }
  },
  mounted(){

  },
  methods:{

  }
}
</script>
<style lang="scss" scoped>
html, body {
  position: relative;
}
body {
  background: #F3F4F6;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 14px;
  color:#000;
  margin: 0;
  padding: 0;
}
.wrapper{
  width: 1580px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  padding-top: 70px;
.title{
    text-align: left;
    margin-left: 10%;
    .name{
      font-size: 48px;
      //font-family: Microsoft YaHei;
      font-weight: 600;
      color: #333333;
    }
    .label{
      font-size: 24px;
      //font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
    }
  }
}
.companyCulture{
  .cultureImgBox{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 50px;
    width: 80%;
    margin: 0 auto;
    .cultureList{
      width: 50%;
      margin: 70px 0 30px;
      color: #333C58;
      .cultureList_item{
        height: 200px;
        display: flex;
        align-items: center;
        img{
          width: 220px;
          margin-right: 30px;
        }
        .cultureList_item_right{
          .p1{
            font-size: 36px;
            margin-bottom: 20px;
          }
        }
      }
    }
  }
}
.companyCulture{
  height: 843px;
}
.employeeStyle{
  background-color: #F3F9FF;
  //height: 979px;
  padding-bottom: 140px;
  .wrapper{
    width: 1628px;
  }
  .employImgBox{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .imgWrapper{
      position: relative;
      width: 492px;
      height: 274px;
      margin: 25px;
      border-radius: 30px;
      overflow: hidden;
      .swiper-slide{
        img{
          border-radius: 24px;
        }
      }
      .swiper-button{
        cursor: pointer;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 60px;
        height: 60px;
        background-size: cover;
        z-index: 98;
        opacity: 0;
        pointer-events: none;
        transition: all 0.5s;
      }
      .swiper-button-prev-new{      
        left: 23px;
        background-image: url("../../assets/img/swiper-left.png")!important;   
        &:hover{
          background-image: url("../../assets/img/swiper-left-light.png")!important;
        }
      }
      .swiper-button-next-new{  
        right: 23px;
        background-image: url("../../assets/img/swiper-right.png")!important;;
        &:hover{
          background-image: url("../../assets/img/swiper-right-light.png")!important;
        }
      }
      .mask{
        border-radius: 0 0 24px 24px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0.9;
        background-color: #000;
        text-align: center;
        //line-height: 274px;
        font-size: 40px;
        //font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        transition: all 0.5s;
        z-index: 99;
        height: 70px;
        .maskP3, .maskP6{
          margin-left: -85px;
        }
        .maskP5{
          margin-left: -122px;
        }
        p{
          height: auto;
          width: 210px;
          /* margin: 0 0 0 0; */
          /* padding-left: 10px; */
          /* height: 100px; */
          text-align: left;
          margin-left: -107px;
          margin-top: 10px;
          position: relative;
          left: 56%;
          .line{
            display: none;
            position: absolute;
            left: 0px;
            // top: 61px;
          }
        }

      }
      &:hover{
        .mask{
          opacity: 0;
          pointer-events: none;
        }  
        .swiper-button{
          opacity: 1;
          pointer-events: all;
        }   
      }
    }
  }
}
</style>